import Trademarks from "./TrademarkTable";

export default Trademarks;
